import Form from 'react-bootstrap/Form'

import './payoutBusinessType.scss'

export const PAYOUT_BUSINESS_TYPES = [
  { value: 'individual', label: 'Individual' },
  { value: 'company', label: 'Company' },
  { value: 'non_profit', label: 'Nonprofit' },
  { value: 'government_entity', label: 'Government entity' },
]

export function isPayoutBusinessType(value) {
  return PAYOUT_BUSINESS_TYPES.some((option) => option.value === value)
}

export default function PayoutBusinessType({
  value,
  onChange,
  currentBusinessType,
  disabled,
  id = 'payout-business-type',
}) {
  const replacing =
    isPayoutBusinessType(currentBusinessType) && currentBusinessType !== value

  return (
    <Form.Group className="form-group payout-business-type" controlId={id}>
      <Form.Label>Account type</Form.Label>
      <Form.Select
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        {PAYOUT_BUSINESS_TYPES.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      <Form.Text className="text-muted d-block mt-2">
        Company, nonprofit, and government payouts go to that organization's
        bank account. Stripe still asks one owner or executive to verify their
        identity.
      </Form.Text>
      {replacing && (
        <Form.Text className="text-danger d-block mt-2">
          Changing this replaces the unfinished Stripe account and starts setup
          again.
        </Form.Text>
      )}
    </Form.Group>
  )
}
